/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  FontWeight, HStack, Popover, Stack, Text,
  UserPreview,
} from '@doveit/bricks';
import { formatDate } from '@doveit/hammer';
import * as styles from './TextPreview.style';

export interface TextPreviewProps {
  author?: string,
  date?: string | Date,
  text: string,
  render?: {
    text?: (text: string) => React.ReactElement,
  }
}

const TextPreview: React.FC<TextPreviewProps> = ({
  author,
  date,
  text,
  render,
}) => (
  <Popover
    trigger={render?.text ? render.text(text) : (
      <Text.Caption css={styles.text}>
        {text}
      </Text.Caption>
    )}
    hasArrow
  >
    <div css={styles.textPopoverWrapper}>
      <Stack gap={100}>
        {((author?.trim() || date?.toString()?.trim())) && (
          <HStack alignItems="center" justifyContent="space-between">
            {author && (
              <UserPreview name={author} size="S">
                {date && (
                  <Text.Caption fontWeight={FontWeight.REGULAR}>
                    {formatDate(new Date(date))}
                  </Text.Caption>
                )}
              </UserPreview>
            )}
          </HStack>
        )}

        <Text.BodySmall>
          {text}
        </Text.BodySmall>
      </Stack>
    </div>
  </Popover>
);

export default TextPreview;
